'use client'

// TODO: Delete this component?
// TODO: Check substations for Dropdown
// TODO: Check scroll on tab click

import {
  CardWeather,
  CardWeatherForecast,
  Container,
  Section
} from '@/ui/components'

import { useStoreI18n } from '@/store'
import { Typo3SectionSpotSanityWeather } from '@/types/typo3'
import { memo, Suspense } from 'react'

import dynamic from 'next/dynamic'

const Pdf = dynamic(() => import('./Pdf'), { ssr: false })

import { Tabs } from 'radix-ui'

interface Props {
  data: Typo3SectionSpotSanityWeather
}

// type ItemKeys = 'today' | 'tomarrow' | 'nextDays'

const SpotSanityContentWeather = ({ data }: Props) => {
  const c = data.content
  const tabItems = ['today', 'tomorrow', 'nextDays']
  const selectedTab = 'today'

  // Stores
  const D = useStoreI18n.use.dictionary()

  return (
    <>
      <div className={''}>
        <Container className={'gap-gutter flex justify-between'}>
          {c?.weatherForecasts?.poweredBy && (
            <h5
              className={'h5 [&_a]:underline [&_a]:hover:no-underline'}
              dangerouslySetInnerHTML={{
                __html: c?.weatherForecasts?.poweredBy
              }}
            ></h5>
          )}
          <Suspense>
            <Pdf data={data} />
          </Suspense>
        </Container>
      </div>
      <Section data={data} anim="fade-in" className={'pt-xl'}>
        <Tabs.Root defaultValue={selectedTab}>
          <Container className="xl:grid xl:grid-cols-3">
            <Tabs.List
              className={'gap-2xs flex xl:col-span-2 xl:w-full'}
              aria-label="Weather"
            >
              {tabItems.map((tab, index) => (
                <Tabs.Trigger
                  className={
                    'text-style-capitalize textstyle-md-button py-xs! px-md! data-[state=active]:bg-primary-400 h-auto! max-h-10! cursor-pointer border-0! bg-neutral-200 text-neutral-600 shadow-none! data-[state=active]:text-neutral-100'
                  }
                  key={index?.toString()}
                  value={tab.toString()}
                >
                  <p className="text-btn text-style-capitalize">
                    {tab === 'today'
                      ? D['fe.weather.tab.today']
                      : tab === 'tomorrow'
                        ? D['fe.weather.tab.tomorrow']
                        : D['fe.weather.tab.nextDays']}
                  </p>
                </Tabs.Trigger>
              ))}
            </Tabs.List>
          </Container>
          <div>
            {tabItems.map((tab, index) => {
              const data =
                c?.weatherForecasts?.[
                  tab === 'today'
                    ? 'today'
                    : tab === 'tomorrow'
                      ? 'tomorrow'
                      : 'nextDays'
                ]
              return (
                <Tabs.Content value={tab} key={index?.toString()}>
                  <CardWeather selectedDate={selectedTab} data={data} />
                  <CardWeatherForecast
                    selectedDate={selectedTab}
                    data={data?.stations?.[0]}
                    stations={c?.subStation}
                  />
                </Tabs.Content>
              )
            })}
          </div>
        </Tabs.Root>
      </Section>
    </>
  )
}

export default memo(SpotSanityContentWeather)
